module.exports = "https://coursera_assets.s3.amazonaws.com/images/3014af623cc0e34bc04e9805f96d24e4.svg";